import { useCosmosTestDetailQuery } from '@innovamat/glow-api-client';
import type { CosmosTestDetail } from '../modules/report/cosmos-test-detail';

type Props = {
  testClassroomUuid: string;
  classroomId: string;
  enabled?: boolean;
};

type UseCosmosTestDetail = {
  data?: CosmosTestDetail;
  isLoading: boolean;
  error: Error | null;
};

function useCosmosTestDetail({
  testClassroomUuid,
  classroomId,
  enabled = true,
}: Props): UseCosmosTestDetail {
  const { data, isLoading, error } = useCosmosTestDetailQuery(
    {
      testClassroomUuid: testClassroomUuid,
      classroomId: classroomId,
    },
    {
      enabled: !!testClassroomUuid && !!classroomId && enabled,
    }
  );

  return {
    data: data?.cosmosTestDetail as CosmosTestDetail,
    isLoading,
    error: (error as Error) || null,
  };
}

export { useCosmosTestDetail };
